import clsx from 'clsx';

import styles from './skeleton.module.scss';

const Skeleton = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div
    data-slot='skeleton'
    className={clsx(styles.skeleton, className)}
    {...props}
  />
);

export { Skeleton };
